import styled from "styled-components";
import { Heading1, SubHeading, CTAButtonWrapper } from "../../../../common/styled-components/styled-components";
import { device, breakpoints } from '../../../../../../app/js/utils/responsive_utilities';
import { styledFont } from '../../../../common/mixins/mixin';
import GrayBackground from "~images/sem/gray_bg.png";
import DesktopBackground from "~images/sem/icons_bg_desktop.png";
import { assetPath } from "../../../../../../app/js/utils/web-helper";
import { Circle } from '../../../../common/styled-components/styled-components';
import { black, mintGreen } from "../../../../../../app/js/components/loggedout/shared-styles/Colors";

export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: url(${assetPath(GrayBackground)}) no-repeat center center;
  background-size: 100% 100%;
  ${styledFont("Graphie")}
  margin-top: -6rem;
  padding-top: 7rem;
  position: relative;

  @media (min-width:${breakpoints.md}px){
    background: url(${assetPath(DesktopBackground)}) no-repeat center center;
    background-size: 100% 100%;
    margin-top: -20rem;
    padding-top: 20rem;
  }
`

export const HeadingText = styled(Heading1)`
  color: ${black};
  margin: auto;
  padding-top: 0.5rem;
  ${styledFont("Graphie", 2.8, 3.2, 7)}
  
  @media ${device.Desktop}{
    ${styledFont("Graphie", 4, 4.8, 7)}
  }
`

export const SubHeadingText = styled(SubHeading)`
  width: 80%;
  color: ${black};
  margin: auto;
  padding-top: 0.5rem;
  ${styledFont("Graphie", 1.6, 2, 6)}

  @media ${device.Desktop}{
      width: 50%;
      ${styledFont("Graphie", 2, 2.4, 6)}
  }
`

export const AnimationWrapper = styled.div`
  margin: 1.5rem auto;
  min-height: 23rem;
  
  @media (min-width:${breakpoints.md}px){
    min-height: 30rem;
    width: 63%;
  }

  @media ${device.PhoneLandscape}{
    width: 63%;
  }


`

export const ButtonWrapper = styled(CTAButtonWrapper)`
  padding-bottom: 6rem;
`

export const OrangeCircle = styled(Circle)`
  background: #FD825D;
  height: 4.3rem;
  width: 4.3rem;
  position: absolute;
  top: 0.5rem;
  left: 40%;

  @media (min-width:${breakpoints.md}px){
    height: 6.8rem;
    width: 6.8rem;
    top: 10.5rem;
    left: 50%;
  }

  @media ${device.Tablet}{
    width: 3.5rem;
    height: 3.5rem;
    top: 10%;
  }
`

export const AquaCircle = styled(Circle)`
  background: ${mintGreen};
  height: 1.5rem;
  width: 1.5rem;
  position: absolute;
  top: 0.4rem;
  left: 33%;
  @media (min-width:${breakpoints.md}px){
    height: 1.6rem;
    width: 1.6rem;
    top: 13.4rem;
    left: 48%;
    background: #7CB7AA;
  }

  @media ${device.Tablet}{
    width: 1.2rem;
    height: 1.2rem;
    top: 12.5%;
  }
`